import type { ExtractPropTypes, PropType } from 'vue'
import type _Image from './image.vue'
import { imageProps, } from 'element-plus'

export const sdImageProps = {
    src               : imageProps.src,
    fit               : { ...imageProps.fit, default: 'cover' },
    hideOnClickModal  : { ...imageProps.hideOnClickModal, default: true }, // 点击遮罩层可关闭 preview
    lazy              : imageProps.lazy,
    scrollContainer   : imageProps.scrollContainer,
    previewSrcList    : imageProps.previewSrcList,
    zIndex            : imageProps.zIndex,
    initialIndex      : imageProps.initialIndex,
    previewTeleported : imageProps.previewTeleported,

    // 扩展属性
    width             : { type: [Number, String] as PropType<string | number>                   }, // 宽度
    height            : { type: [Number, String] as PropType<string | number>                   }, // 高度
    minHeight         : { type: [Number, String] as PropType<string | number>                   }, // 最小高度
    circle            : { type: Boolean                                       , default: false  }, // 圆形显示
    borderRadius      : { type: [Number, String] as PropType<string | number> , default: 4      }, // 圆角值
    preview           : { type: Boolean                                       , default: true   }, // 是否点击可预览
}

export type SdImageProps    = ExtractPropTypes<typeof sdImageProps>
export type SdImageInstance = InstanceType<typeof _Image>

